<template>
    <fragment>
        <div class="col-3" v-for="(email,index) in value">
                  <email-address v-model="value[index]" @send-email="sendEmail" @update-default="updateDefault" @add-email="add" @remove-email="remove" :index="index" :readOnly="readonly" :first="index==0" :last="index==value.length-1"></email-address>
        </div>
        </fragment>
</template>
<script>
    import axios from 'axios';
  export default {
        name: 'emailaddresslist',
       
        props: {
            readonly: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                entityType: 'emailaddress',
                addTitle :'Aggiungi nuovo indirizzo email'
            }

        },
        components: {
           
        },
        methods: {
            updateDefault(email) {
                for (var i = 0; i < this.value.length; i++) {
                    if (this.value[i].emailId != email.emailId) {
                        this.value[i].default = false;
                        }
                }
                
            },
            add() {
                var me = this;
                axios.get('utility/new/' + me.entityType).then(response => {
                    response.data.isImported = false;
                    me.value.push(response.data);

                });
            },
            sendEmail(email,evt){
                var me = this;
              
                if(this.$parent.sendEmail){
this.$parent.sendEmail(email);

                }
             

            }
            , remove(email) {
                
                var me = this;
                var delIndex = -1;

               for (var i = 0; i < this.value.length; i++) {
                    if (this.value[i].emailAddressId == email.emailAddressId) {
                        delIndex = i;
                        break;
                        }
                }
                if (delIndex >= 0) {
                    this.value.splice(delIndex, 1);
                }
            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
